angular.module('leanlaw').directive('llOverviewWip', [function () {
  return {
    restrict: 'EA',
    template: require("./views/overviewWip.html"),
    scope: {
      matter: "=",
      client: "="
    },
    controller: ['$scope', 'singleRequest', function ($scope, singleRequest) {
      $scope.vm = {
        wip: undefined,
        sort: 'data.amounts.total',
        reverse: true,
        hasExpense: false
      };
      $scope.$watchGroup(['client', 'matter'], () => {
        const {
          client,
          matter
        } = $scope;
        if (matter) {
          load({
            matterId: matter.id
          });
        }
        if (client) {
          load({
            clientId: client.id
          });
        }
      });
      function load(options) {
        $scope.vm.wip = undefined;
        const query = {
          ...options,
          primary: 'users',
          data: 'hours,services,expenses,charges',
          billed: false,
          scope: 'all',
          source: 'client',
          status: 'active'
        };
        singleRequest.apiCall('wip').getReport(query).then(wip => {
          if (!wip) return;
          $scope.vm.wip = wip;

          // We are asking the API to report by user, so expenses for users are in
          // wip.data and unassigned expenses are in wip.unallocated. Here we sum it up for the ui
          $scope.vm.wip.expenses = wip.data.amounts.expenses + (wip.unallocated && wip.unallocated.amounts.expenses || 0);
          $scope.vm.wip.charges = wip.data.amounts.charges + (wip.unallocated && wip.unallocated.amounts.charges || 0);
          $scope.vm.wip.total = $scope.vm.wip.expenses + $scope.vm.wip.charges + $scope.vm.wip.data.amounts.hours;
          $scope.vm.hasExpense = $scope.vm.wip.total > 0;
        });
      }
    }]
  };
}]);